import { render } from "./Investment_chart.vue?vue&type=template&id=7889c134"
import script from "./Investment_chart.vue?vue&type=script&lang=js"
export * from "./Investment_chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__